import _filter from 'lodash/filter';

/**
 * HOHO BUILDER - ADD RESERVATION SECTOR PAYLOAD [updated]
 *
 * @param {Array} arr - Booking response payload
 * @param {String} departureDate - Selected departure
 * @param {number} startCityID - Start city id
 * @param {number} endCityId - End city id
 * @param {number} price - price
 */
 export function AddReservationsPayload(arr, departureDate, startCityID, endCityId, price){

   let _trips = {};
   let _passengers = [];

   //Find trips based on booking_identifier of first openItineraryModal
   const addReservation = _filter(arr.trips, ['type', 'hoho'])[0];

  _trips.booking_identifier = (addReservation.booking_identifier === null) ? null : addReservation.booking_identifier;
  _trips.tour_id = addReservation.tour_id;

  for(let j = 0; j < addReservation.passengers.length; j++){
     _passengers.push({
      "identifier":addReservation.passengers[j].trip_passenger_identifier,
      "price": price,
      "quantity":addReservation.passengers.length,
      "reservations":[{
        "date_for":departureDate,
        "start_city_id":startCityID,
        "end_city_id":endCityId,
        "price":price
      }]
    });
  }

   _trips.passengers = _passengers;

   return { "trips": [ _trips ]};

 }



 /**
  * HOHO BUILDER - UPDATE SECTOR PAYLOAD [updated]
  *
  * @param {Array} arr - Booking response payload
  * @param {number} reservationIndex - Index of reservation item to update
  * @param {String} updatedDate - new date to update
  */
  export function UpdateReservationsPayload(arr, reservationIndex, updatedDate){

    let _trips = {};
    let _passengers = [];

    //Find trips based on booking_identifier of first openItineraryModal
    const updateReservation = _filter(arr.trips, ['type', 'hoho'])[0];

   _trips.booking_identifier = (updateReservation.booking_identifier === null) ? null : updateReservation.booking_identifier;
   _trips.tour_id = updateReservation.tour_id;

   for(let j = 0; j < updateReservation.passengers.length; j++){
      _passengers.push({
       "identifier":updateReservation.passengers[j].trip_passenger_identifier,
       "price": parseInt(updateReservation.passengers[j].price,10),
       "quantity":updateReservation.passengers.length,
       "reservations":[{
         "laravel_reservation_identifier":arr.sectors[reservationIndex].transfer.laravel_reservation_identifier,
         "date_for":updatedDate,
         "start_city_id":arr.sectors[reservationIndex].transfer.start_city_id,
         "end_city_id":arr.sectors[reservationIndex].transfer.end_city_id,
         "price":parseInt(arr.sectors[reservationIndex].transfer.price,10)
       }]
     });
   }

    _trips.passengers = _passengers;

    return { "trips": [ _trips ]};
  }




 /**
  * HOHO BUILDER - REMOVE RESERVATION SECTOR PAYLOAD [updated]
  *
  * @param {Array} arr - Booking response payload
  * @param {String} tourID - Tour ID of trip
  */
export function RemoveReservationsPayload(arr, tourId){

    let _trips = {};
    let _passengers = [];
    const removeTrips = _filter(arr.trips, ['tour_id', tourId])[0];


    _trips.booking_identifier = (removeTrips.booking_identifier === null) ? null : removeTrips.booking_identifier;

    for(let j = 0; j < removeTrips.passengers.length; j++){
     _passengers.push({
       "identifier":removeTrips.passengers[j].trip_passenger_identifier,
       "reservations":[{
        "identifier": arr.sectors[arr.sectors.length - 1].transfer.laravel_reservation_identifier
       }]
     });
    }
    _trips.passengers = _passengers;

    return { "trips": [ _trips ]};
}



/**
 * HOHO BUILDER - ADD PASSENGER RESERVATION PAYLOAD [FOR LATER USE]
 *
 * @param {Array} arr - Booking response payload
 */
 export function AddPassengerPayload(arr, paxArray){

    let payload = {};

    payload.booking_information = {
     "iso_currency_code":arr.trips[0].iso_currency_code
    }

    payload.trips = [{
      "tour_id": arr.trips[0].tour_id,
      "departure_date": arr.trips[0].departure_date
    }]

    payload.passengers = paxArray;

    return payload;
 }


 /**
  * HOHO BUILDER - REMOVE PASSENGER RESERVATION PAYLOAD [FOR LATER USE]
  *
  * @param {Array} arr - Booking response payload
  */
  export function RemovePassengerPayload(arr){

    let payload = {};
    let passengers = [];

    for(let i = 0; i < arr.trips.length; i++){
      for(let j = 0; j < arr.trips[i].passengers.length; j++){
        passengers.push({
          "identifier":arr.trips[i].passengers[j].trip_passenger_identifier
        })
      }

      payload.trips = [{
        "identifier": arr.trips[i].booking_identifier,
        "passengers":passengers
      }]
    }

     payload.passengers = passengers;

     return payload;
  }


  /**
   * HOHO BUILDER - ADD TRIP RESERVATION PAYLOAD [updated]
   *
   * @param {Array} arr - Booking response payload
   * @param {String} tourID - Tour ID of trip
   * @param {String} departureDate - departure date of trip
   * @param {String} cityID - City ID of the last reservation item 'end_city_id'
   */
   export function AddTripPayload(arr, tourID, departureDate, cityID){

     let payload = {};
     let passengers = [];

     payload.booking_information = {
      "iso_currency_code":arr.iso_currency
     }

     payload.trips = [{
       "tour_id": tourID,
       "city_id":cityID,
       "departure_date": departureDate
     }]

    for(let i = 0; i < arr.passengers.length; i++){
      passengers.push({
        "passenger_identifier":arr.passengers[i].passenger_identifier
      })
    }

     payload.passengers = passengers;

     return payload;
   }





   /**
    * HOHO BUILDER - REMOVE TRIP RESERVATION PAYLOAD [updated]
    *
    * @param {Array} arr - Booking response payload
    */
    export function RemoveTripPayload(arr, tourId){

      let _trips = {};
      let _passengers = [];
      const removeTrips = _filter(arr.trips, ['tour_id', tourId])[0];

      _trips.booking_identifier = (removeTrips.booking_identifier === null) ? null : removeTrips.booking_identifier;

      for(let j = 0; j < removeTrips.passengers.length; j++){
       _passengers.push({
         "trip_passenger_identifier":(removeTrips.passengers[j].trip_passenger_identifier === null) ? removeTrips.passengers[j].laravel_trip_passenger_identifier : removeTrips.passengers[j].trip_passenger_identifier,
         "cancel": true
       });
      }
      _trips.passengers = _passengers;


      return { "trips": [ _trips ]};
    }



    /**
     * HOHO BUILDER - ADD ACCOMMODATION PAYLOAD [new]
     *
     * @param {Array} arr - Itineraries response payload
     * @param {boolean} isToggle - Price summary accomodation toggle
     * @param {boolean} isChecked - Price summary accomodation toggle (on/off)
     * @param {string} globalRoomType - Global room type paramater
     */
     export function AddAccomodationPayload(arr, isToggle, isChecked, globalRoomType){
  

        let itineraryElements = document.querySelectorAll('.details .itinerary-view .Collapsible .itinerary--description');
        let cardPriceElements = document.querySelectorAll('.details .itinerary-view .Collapsible .itinerary--description input[data-checked="true"]');
        let _trips = {};
        let _properties = [];
        let _accomodationData;
        let tripsData = _filter(arr.trips,['type', 'hoho'])[0];

        if(!isToggle){
           _accomodationData = accomodationCardData(itineraryElements, cardPriceElements);
         }else{
          _accomodationData = accomodationCardDataToggle(arr, isChecked);
         }

           

        _trips.tour_id = tripsData.tour_id;
        _trips.booking_identifier = tripsData.booking_identifier;
         _trips.properties_room_type = globalRoomType;

        for(let i=0; i < arr.sectors.length; i++){

          if(arr.sectors[i].duration > 0){

              let date_nights = (arr.sectors[i].accommodation.date_nights !== undefined) ? arr.sectors[i].accommodation.date_nights : [];
              let room_type = (arr.sectors[i].accommodation.length === 0 || arr.sectors[i].accommodation.rooms.length === 0) ? null : _accomodationData[i].room_type;
              let room_type_name = (arr.sectors[i].accommodation.length === 0 || arr.sectors[i].accommodation.rooms.length === 0) ? null : _accomodationData[i].room_type_name;
              let room_type_code = (arr.sectors[i].accommodation.length === 0 || arr.sectors[i].accommodation.rooms.length === 0) ? null : _accomodationData[i].room_type_code;
              let price_pp_pn =  (arr.sectors[i].accommodation.length === 0 || arr.sectors[i].accommodation.rooms.length === 0) ? null : _accomodationData[i].priceppnn;
              let identifier = arr.sectors[i].tour_id === tripsData.tour_id ? arr.sectors[i].city_ctfl_id : arr.sectors[i].product_ctfl_id;

              _properties.push({
                "identifier": (arr.sectors[i].accommodation.length === 0) ? null : arr.sectors[i].transfer.laravel_reservation_identifier,
                "ctfl_id": (arr.sectors[i].accommodation.length === 0) ? null : identifier,
                "sector_type": arr.sectors[i].type,
          			"property_name": (arr.sectors[i].accommodation.length === 0) ? null : arr.sectors[i].accommodation.property_name,
          			"property_id": (arr.sectors[i].accommodation.length === 0) ? null : arr.sectors[i].accommodation.property_id,
          			"booking_reference": null,
          			"passenger_index": 0,
          			"iso_currency_code": (arr.sectors[i].accommodation.length === 0) ? null : arr.sectors[i].accommodation.iso_currency,
          			"amount_paid": 0,
          			"amount_due": (arr.sectors[i].accommodation.length === 0) ? null : _accomodationData[i].price,
          			"pax_number": (arr.sectors[i].accommodation.length === 0) ? null : arr.sectors[i].pax_number,
          			"start_date": (arr.sectors[i].accommodation.length === 0) ? null : arr.sectors[i].accommodation.start_date,
          			"num_nights": (arr.sectors[i].accommodation.length === 0) ? null : arr.sectors[i].accommodation.num_nights,
          			"status": (arr.sectors[i].accommodation.length === 0) ? null : arr.sectors[i].accommodation.status,
          			"room_type": room_type,
          			"room_type_name": room_type_name,
                "bookings": (arr.sectors[i].accommodation.length === 0) ? [] : accomodationBookingsHelper(date_nights, room_type, room_type_name, room_type_code, price_pp_pn)
              })
            }

            _trips.properties = _properties;
         }

        return { "trips": [ _trips ]};
     }


    function accomodationBookingsHelper(date_nights, room_type, room_type_name, room_type_code, price_pp_pn){

       let _bookings = [];

       for(let i=0; i < date_nights.length; i++){
         _bookings.push({
           "overnight_date": date_nights[i],
           "room_type": room_type,
           "room_type_name": room_type_name,
           "room_type_code": room_type_code,
           "price": price_pp_pn
         })
       }

       return _bookings;
     }

    //Get all accomodation data
    function accomodationCardData(itineraryElements, cardPriceElements){

      let arr = [];

      //Populate empty array values based on number of cards
      for(let ii = 0; ii < itineraryElements.length; ii++){
        arr.push({
          "room_type": "none",
          "room_type_name": "none",
          "room_type_code": null,
          "priceppnn": 0,
          "price": 0
        });
      }

      //Override card values with valid card values
      for(let i = 0; i < cardPriceElements.length; i++){
        arr[cardPriceElements[i].dataset.index].room_type = cardPriceElements[i].dataset.roomtype === undefined ? "none" :  cardPriceElements[i].dataset.roomtype;
        arr[cardPriceElements[i].dataset.index].room_type_name = cardPriceElements[i].dataset.roomtypename === undefined ? "none" : cardPriceElements[i].dataset.roomtypename;
        arr[cardPriceElements[i].dataset.index].room_type_code = cardPriceElements[i].dataset.roomcode === undefined ? null : cardPriceElements[i].dataset.roomcode;
        arr[cardPriceElements[i].dataset.index].priceppnn = cardPriceElements[i].dataset.pricepppn === undefined ? 0 : parseFloat(cardPriceElements[i].dataset.pricepppn);
        arr[cardPriceElements[i].dataset.index].price = cardPriceElements[i].dataset.price === undefined ? 0 : parseFloat(cardPriceElements[i].dataset.price);
      }

      return arr;

    }

    function accomodationCardDataToggle(itinerary, isChecked){

      let arr = [];

      for(let ii = 0; ii < itinerary.sectors.length; ii++){

        if(isChecked){

          arr.push({
            "room_type": (itinerary.sectors[ii].duration > 0 && itinerary.sectors[ii].accommodation.rooms.length > 0) ? itinerary.sectors[ii].accommodation.rooms[0].type : "none",
            "room_type_name": (itinerary.sectors[ii].duration > 0 && itinerary.sectors[ii].accommodation.rooms.length > 0) ? itinerary.sectors[ii].accommodation.rooms[0].type_name : "none",
            "room_type_code": (itinerary.sectors[ii].duration > 0 && itinerary.sectors[ii].accommodation.rooms.length > 0) ? itinerary.sectors[ii].accommodation.rooms[0].code : null,
            "priceppnn":(itinerary.sectors[ii].duration > 0 && itinerary.sectors[ii].accommodation.rooms.length > 0) ? parseFloat(itinerary.sectors[ii].accommodation.rooms[0].quote_price_pp_pn) : 0,
            "price": (itinerary.sectors[ii].duration > 0 && itinerary.sectors[ii].accommodation.rooms.length > 0) ? parseFloat(itinerary.sectors[ii].accommodation.rooms[0].quote_price) : 0
          });

        }
        else{
          arr.push({
            "room_type": "none",
            "room_type_name": "none",
            "room_type_code": null,
            "priceppnn": 0,
            "price": 0
          });
        }

      }


      return arr;
    }



// WEBPACK FOOTER //
// ./src/helpers/bookingHelper.js